export default "__VITE_ASSET__ByclK$N4__"